import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { PrivacyPolicyEN_US } from './PrivacyPolicyEN_US';
import { PrivacyPolicyES_CO } from './PrivacyPolicyES_CO';
import { PrivacyPolicyDE } from './PrivacyPolicyDE';
import { PrivacyPolicyPT } from './PrivacyPolicyPT';
import { PrivacyPolicyNL_NL } from './PrivacyPolicyNL_NL';
import { PrivacyPolicyFR_FR } from './PrivacyPolicyFR_FR';
import { PrivacyPolicyRU_RU } from './PrivacyPolicyRU_RU';
import { PrivacyPolicyHR_HR } from './PrivacyPolicyHR_HR';
import { PrivacyPolicyUK } from './PrivacyPolicyUK';

const privacyPolicyForms = {
  'es-CO': PrivacyPolicyES_CO,
  de: PrivacyPolicyDE,
  pt: PrivacyPolicyPT,
  'nl-NL': PrivacyPolicyNL_NL,
  'fr-FR': PrivacyPolicyFR_FR,
  'ru-RU': PrivacyPolicyRU_RU,
  'hr-HR': PrivacyPolicyHR_HR,
  uk: PrivacyPolicyUK,
};

const Styled = styled.div`
  padding: 0 20px;
  height: 70vh;
  overflow: auto;
  background-color: white;

  h4 {
    text-align: center;
  }

  ol {
    padding-left: 15px;
    li {
      p {
        text-indent: 15px;
      }
    }
  }
`;

export const PrivacyPolicy = ({ userLocale }) => {
  const PrivacyPolicyForm = React.useMemo(() => {
    return privacyPolicyForms?.[userLocale] ?? PrivacyPolicyEN_US;
  }, [userLocale]);

  return (
    <Styled className={cn('privacy')}>
      <PrivacyPolicyForm />
    </Styled>
  );
};
